import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToRepairReportApiParams } from '#/api/aftersalesMgmt/repairReport/listQueryToApiParams';

/**
 * 維修報告列表（target：`GET /aftersales/repair-report`）。
 * BE 未部署時呼叫端需處理錯誤 toast。
 *
 * @param {object} listQuery
 */
export async function fetchRepairReportList(listQuery) {
  const { data: raw } = await request.get('/aftersales/repair-report', {
    params: listQueryToRepairReportApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
